/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiSubscriptionMerchant;
(function (ApiSubscriptionMerchant) {
    ApiSubscriptionMerchant["SUBSCRIPTION_MERCHANT_STRIPE"] = "SubscriptionMerchantStripe";
    ApiSubscriptionMerchant["SUBSCRIPTION_MERCHANT_SHOPIFY"] = "SubscriptionMerchantShopify";
})(ApiSubscriptionMerchant || (ApiSubscriptionMerchant = {}));
export function ApiSubscriptionMerchantFromJSON(json) {
    return ApiSubscriptionMerchantFromJSONTyped(json, false);
}
export function ApiSubscriptionMerchantFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiSubscriptionMerchantToJSON(value) {
    return value;
}
